export enum PastEventEventsEnum {
	NewPastEventCreated = 'past-event.created',
	UserToPastEventSeen = 'user-to-past-event.seen'
}

export enum ActivityTypeEnum {
	Verified = 'verified',
	Unverified = 'unverified',
}
